import { isEmpty } from 'lodash'
import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { Box } from 'theme-ui'
import { loginFunction } from '../../api/loginFunction'
import { createReports } from '../../api/reportFunction'
import { notifyErrorAPI, notifySuccess } from '../../components/Notif'
import useCurrentUserStore from '../../stores/currentUser'
import useIdentifierStore from '../../stores/identifier'
import Header from './components/Header'
import ReportForm, { ReportFormProps } from './components/ReportForm'
import { normalizeFormToApi } from './normalizer'

const CreateLaporanPengaduan = () => {
  const { currentUser, setCurrentUser } = useCurrentUserStore()
  const role = currentUser?.data?.roles
  const { setIdentifer } = useIdentifierStore()

  const { mutateAsync: createReport, isLoading } = useMutation(
    (data: any) =>
      createReports(data, {
        headers: {
          Authorization: role === 'user' ? currentUser.authToken : null,
        },
      }),
    {
      onError: notifyErrorAPI,
    }
  )

  const loginM = useMutation(loginFunction, {
    onError: notifyErrorAPI,
  })

  const navigate = useNavigate()

  const handleSubmit: ReportFormProps['onSubmit'] = function (values, formik) {
    const report = {
      report: {
        ...normalizeFormToApi(values).report,
        identifierId: currentUser.data?.email,
      },
    }

    createReport(report).then((response) => {
      const reportId = response?.data?.data?.id
      notifySuccess('Laporan berhasil dibuat')
      formik.resetForm()

      if (isEmpty(currentUser)) {
        const { identifierId, identifierPassword } =
          response?.data?.identifier || {}

        setIdentifer({ identifierId, identifierPassword })

        loginM
          .mutateAsync({
            auth: { email: identifierId, password: identifierPassword },
          })
          .then((response) => {
            setCurrentUser(response.data)
            notifySuccess('Login successfull')
            navigate(`/laporan-pengaduan/${reportId}/edit`)
          })
      } else {
        navigate(`/laporan-pengaduan/${reportId}/edit`)
      }
    })
  }

  return (
    <Box p="3">
      <Header />
      <ReportForm
        initialValues={{}}
        onSubmit={handleSubmit}
        disabled={isLoading}
      />
    </Box>
  )
}

export default CreateLaporanPengaduan
